@if (this.productLine$ | async; as productLine) {
  <div
    class="tab-pane fade flex-even active show"
    id="insuranceDocuments"
    role="tabpanel"
    aria-labelledby="insuranceDocuments-tab"
    >
    @if (productLine.products.length != 0) {
      <div
        class="d-flex flex-column h-100"
        >
        <div class="row mt-2">
          <table class="table table-striped border-bottom">
            <thead>
              <tr>
                <th>
                  <a translate>PRODUCT_LBL_NAME</a>
                </th>
                <th class="text-center">
                  <a translate>PRODUCT_LBL_ACTIVE</a>
                </th>
              </tr>
            </thead>
            <tbody>
              @for (product of productLine.products; track product.id) {
                <tr [routerLink]="'/Insurance/Products/Details/' + product.id" class="row-action">
                  <td>{{ product.name }}</td>
                  <td class="text-center">
                    @if (product.isActive) {
                      <app-badge
                        [message]="'PRODUCT_LBL_ACTIVE'"
                        [color]="'light-success'"
                        />
                    } @else {
                      <app-badge [message]="'PRODUCT_LBL_INACTIVE'" [color]="'light-danger'"
                        />
                    }
                  </td>
                  <!-- <td>{{ product.isActive }}</td> -->
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }
  </div>
}

